import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';
import { PepDisclosureModel } from '../../../slides/reviewAndSubmit/submit/pepModel.model';
import { BorrowerOtherIncome } from '../borrower-other-income.model';
import { BorrowerAsset } from './borrower-asset.model';
import { BankScrape } from './borrower-bank-scrape.model';
import { BorrowerEmployment } from './borrower-employment.model';
import { BorrowerProperty } from './borrower-property.model';
import { ClientJourneyEngagement } from './client-journey-engagement';
import { Contact } from './contact.model';

@HateoasResource('borrowers')
export class Borrower extends Resource {
  /// Borrower Id
  id: number;

  /// Contact Id
  contactId: number;

  /// Order
  order: number;

  //NoaConsent
  noaConsent: boolean;

  /// Contact
  contact: Contact;

  ///Employments
  employments: Array<BorrowerEmployment>;
  //Other incomes
  otherIncomes: Array<BorrowerOtherIncome>;
  assets: Array<BorrowerAsset>;
  bankScrapes: Array<BankScrape>;
  //properties
  properties: Array<BorrowerProperty>;

  cjEngagement: ClientJourneyEngagement;

  //local model not backed by the db
  pepDisclosureModel: PepDisclosureModel = new PepDisclosureModel();
}

export function getPrimaryBorrower(borrowers: Borrower[]): Borrower {
  return borrowers.sort((b1, b2) => {
    return b1.order > b2.order ? 1 : -1;
  })[0];
}

export function getPrimaryBorrowerId(borrowers: Borrower[]): number {
  return getPrimaryBorrower(borrowers).id;
}
